import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { map, Observable } from 'rxjs';
import { adminUrls, donationUrls } from '../integration-urls/admin-urls';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  admin = adminUrls;
  donation = donationUrls;

  constructor(private _http: HttpClient) { }

  getData(url: string): Observable<any> {
    return this._http.get(url);
  }

  getCustomToken(url: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this._http.get(url, { headers, responseType: 'text' });
  }

  postInLineReview(postData: any, url: any): Observable<any> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this._http.post(url, postData, { headers, responseType: 'text' })
  }

  postData(url: string, data: any): Observable<any> {
    return this._http.post(url, data);
  }

  sendNotification(data: any): Observable<any> {
    const url = this.donation.SendNotification.url;
    return this._http.post(url, data);
  }

  exporttoXL(downloadURL: string, exportdata: any) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/vnd.ms-excel');
    return this._http.post(downloadURL, exportdata, {
      headers: headers,
      responseType: 'arraybuffer'
    }).pipe(map((res: any) => new Blob([res], { type: 'application/vnd.ms-excel' })));
  }


  postTextRes(url: string, data: any): Observable<any> {
    return this._http.post(url, data, { responseType: 'text' });
  }

  deleteData(url: string): Observable<any> {
    return this._http.delete(url);
  }
}
